import { get } from 'svelte/store'

import { messages } from '$lib/messages'
import { apiPostJson } from '$lib/proxy/apiProxy'
import { debounced, SemaphoreKey, semaphores, waitDebouncedFinish } from '$lib/semaphores'

import { openai_thread_item_store } from './openai_thread_item'
import { type OpenaiThreadItem } from './types'


export async function SetOpenaiThreadItem(updates: OpenaiThreadItem | null, skipSave = false) {

	if (!updates) return

	if (updates.id != get(openai_thread_item_store)?.id) {
		await ensureSave(false)
	}
	openai_thread_item_store.set(updates)

	if (skipSave) return
	debounced(SemaphoreKey.OpenaiThreadItem, saveData)
}


async function saveData() {

	const newData = get(openai_thread_item_store)

	const jsonData = await apiPostJson('/openai_thread_item/upsert', newData)
	if (jsonData?.error) {
		messages.error('Could not update db.')
	}

}


async function forceSaveData() {
	return await debounced(SemaphoreKey.OpenaiThreadItem, saveData, 0)
}


async function ensureSave(forceSave: boolean) {
	const semaphoreValue = get(semaphores).openai_examples?.valueOf() ?? 0
	if (semaphoreValue > 0 || forceSave) {
		await forceSaveData()
		await waitDebouncedFinish(SemaphoreKey.OpenaiThreadItem)
	}
}